<template>
  <div class="container">
    <div class="special-card light">
      <div class="special-card-left">
        <div class="tips">时刻</div>
        <div class="title">“代码之外，记录生活”</div>
        <div class="description">碎片随感，定格日常瞬间，用图文记下生活点滴，留下属于自己的片刻回忆。</div>
        <router-link to="/moment" class="link">去看看 ></router-link>
      </div>
      <img class="special-card-right" src="@/assets/moment.webp" alt="时刻"/>
    </div>
    <div class="special-card dark">
      <div class="special-card-left">
        <div class="tips">工具</div>
        <div class="title-color">“聚器于此，相与共享”</div>
        <div class="description">集纳好物，整理链接与程序，欢迎取用、推荐或是自留，盼能为你赋能。</div>
        <router-link to="/tool" class="link">去使用 ></router-link>
      </div>
      <img class="special-card-right" src="@/assets/tool.webp" alt="工具"/>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  padding: 40px 0;
  background: var(--laputa-body-background-other);
}
.group-header h2 {
  font-size: 40px;
  font-weight: 700;
  margin: 0 0 8px;
  color: var(--laputa-near‑black);
}

.special-card {
  width: 90%;
  border-radius: 30px;
  max-width: 1200px;
  position: relative;
  display: flex;
  overflow: hidden;
  height: 500px;
}
/* 浅色主题 */
.special-card.light {
  background: var(--laputa-content);
}
/* 深色主题 */
.special-card.dark {
  background: var(--laputa-card-background-black);
}

.special-card-left {
  padding: 54px 0 54px 75px;
  z-index: 1;
  width: 100%;
  position: relative;
}

.special-card-left .tips {
  font-size: 18px;
  font-weight: bold;
  color: var(--laputa-primary);
}

.special-card-left .title {
  font-size: 40px;
  font-weight: bold;
  line-height: 1.2;
  margin-top: 8px;
  max-width: calc(100% - 700px);
}
/* 浅色标题颜色 */
.special-card.light .title {
  color: var(--laputa-common-font-color);
}
/* 深色标题颜色 */
.special-card.dark .title {
  color: var(--laputa-white);
}

.special-card-left .description {
  font-size: 16px;
  margin-top: 24px;
  opacity: 0.8;
  line-height: 1.2;
  max-width: calc(100% - 700px);
}
.special-card.light .description {
  color: var(--laputa-common-secondary-font-color);
}
.special-card.dark .description {
  color: var(--laputa-light-gray);
}

.special-card-right {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  z-index: 0;
}

.link {
  cursor: pointer;
  position: absolute;
  bottom: 56px;
  display: flex;
  align-items: center;
  padding: 6px 20px;
  color: var(--laputa-primary);
  font-size: 15px;
  transition: ease-in-out 0.3s;
  width: fit-content;
  white-space: nowrap;
}
.link:hover{
  opacity:0.7;
}

.title-color {
  font-size: 40px;
  font-weight: bold;
  line-height: 1.2;
  margin-top: 8px;
  max-width: calc(100% - 700px);
  letter-spacing: 0.02em;
  background: linear-gradient(90deg, #ffd055, #ff8855, #e86464);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

@media (max-width: 768px) {
  .container {
    gap: 24px;
    padding: 24px 0;
  }
  .special-card {
    width: 94%;
    border-radius: 22px;
    /* 取消固定高度，高度自适应内容 */
    height: auto;
    flex-direction: column;
  }

  .special-card-left {
    padding: 32px 24px;
    width:100%;
  }

  .special-card-left .tips {
    font-size: 16px;
  }

  .special-card-left .title,
  .title-color {
    font-size: 26px;
    /* 删掉会算成负数的宽度限制 */
    max-width: unset;
  }

  .special-card-left .description {
    font-size: 15px;
    max-width: unset;
    margin-top:16px;
    line-height:1.5;
  }

  .special-card-right {
    position: static; /* 取消绝对定位，图片流放到文字下面 */
    width: 100%;
    height: auto;
    justify-content: center;
  }
  .special-card-right img {
    width: 80%;
    height: auto;
    object-fit: contain;
  }

  .link {
    position: static; /* 链接不再绝对定位 */
    margin-top:24px;
    bottom:unset;
    padding: 5px 16px;
    font-size:14px;
  }
}


</style>
